var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        clientId: _vm.clientId,
        setTitle: _vm.title,
        channels: _vm.channels,
        apiOrigin: _vm.apiOrigin
      }
    },
    [
      _c("div", [
        _vm.clientId == 320598
          ? _c("div", { staticClass: "main clear" }, [
              _c("div", { staticClass: "about n-about" }, [
                _c("dl", [
                  _c("div", { staticClass: "title" }, [
                    _c("i"),
                    _vm._v("关于我们")
                  ])
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        "吴江新闻网是由中共吴江区委宣传部、吴江区融媒体中心联合打造的网络新媒体平台。\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "作为吴江地区成立最早的主流新闻门户网站，吴江新闻网于2008年8月6日正式运营，2009-2013年度连续五年获评“全国百强新闻网站”，2013年获中国网络舆情引导最佳贡献奖。吴江新闻网选送的作品，连续多年获得中国地市报网络好新闻奖一、二、三等奖，江苏网络好新闻奖三等奖，苏州市新闻奖一、二、三等奖等荣誉。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "2017年8月6日，为顺应移动互联网时代的发展潮流，吴江新闻网改版升级，着力体现三个“更加突出”——更加突出原创内容、更加突出移动互联网体验、更加突出融媒体三屏合一。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "distance" }, [
                      _vm._v(
                        "\n                            基于吴江新闻网的平台效应，吴江区融媒体中心新媒体事业十余年来得到飞速发展，目前已经形成了以吴江新闻网为基础平台、集“两微一端一网一论坛”于一体、多种传播业态齐头发展的全媒体传播新格局，在全国同级网络媒体中稳居第一方阵，为更好地服务吴江区委区政府中心工作、服务百姓民生提供了全媒体发布平台。\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "info distance" }, [
                      _vm._v(
                        "网站办公电话：0512-63498235\n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        " 网站举报电话：0512-63498235\n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        " 网站传真电话：0512-63484356\n                            "
                      ),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "info distance" }, [
                      _vm._v("地址：苏州市吴江区鲈乡南路1887号 邮编：215200")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c("div", { staticClass: "title", attrs: { id: "rexian" } }, [
                    _c("i"),
                    _vm._v("新闻热线")
                  ])
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("p", [
                    _vm._v(
                      "\n                        寻求报道，请您联系：0512-63480924\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c(
                    "div",
                    { staticClass: "title", attrs: { id: "guanggao" } },
                    [_c("i"), _vm._v("广告合作")]
                  )
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("p", [
                    _vm._v(
                      "\n                        商务、品牌推广，请您联系：0512-63491926\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: "/public/w/img/320598/about.png", alt: "..." }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 410600
          ? _c("div", { staticClass: "main clear" }, [
              _c("div", { staticClass: "about n-about" }, [
                _c("dl", [
                  _c("div", { staticClass: "title" }, [
                    _c("i"),
                    _vm._v("关于我们")
                  ])
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        "鹤壁网是鹤壁市广播电视台主办的市重点新闻网站，网站原名鹤视新闻网，于2002年5月上线开通，2011年6月经河南省新闻办批复后更名为鹤壁网（豫新网文[2011]3号），网站的英文域名：“hebitv.com ”“hebitv.net ”，中文域名：“鹤壁网.cn”“鹤壁网.com”。\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "2017年12月，为顺应移动互联网时代的发展潮流，鹤壁网改版升级，着力体现三个“更加突出”-----更加突出原创内容、更加突出移动互联网体验、更加突出融媒体三屏合一，是集在线直播、资讯信息、便民服务、生活应用为一体的全资讯、综合性服务网站。\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "distance" }, [
                      _vm._v(
                        "\n                                2012年1月入选第三批全省百家网站建设推进工程（豫宣通[2012]7号），2015年6月获得河南省网信办颁发的《河南省互联网新闻信息服务许可证》，许可证编号：01201512001。\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "info distance" }, [
                      _vm._v(
                        "\n                          网站办公电话：0392-3331719 \n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        " 网站举报电话：0392-3331766                                \n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            网站举报邮箱：wuxianhebi@163.com\n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            举报中心电子信箱：hbsjbzx@163.com\n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        " 鹤壁市互联网违法和不良信息举报平台电话：0392-3316866\n                            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            鹤壁市互联网违法和不良信息举报平台邮箱：hbsjbzx@163.com\n                        "
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 321300
          ? _c("div", { staticClass: "main clear" }, [
              _c("div", { staticClass: "about n-about" }, [
                _c("dl", [
                  _c("div", { staticClass: "title" }, [
                    _c("i"),
                    _vm._v("关于我们")
                  ])
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        "“速新闻”新闻客户端是宿迁市委、市政府为贯彻中央加强媒体融合要求而重点打造的新兴主流媒体。\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "“速新闻”2014年12月26日正式上线，以新闻为核心产品，便民服务为延伸功能，与报纸、电视一起构成宿迁市域媒体的三驾马车。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "“速新闻”由宿迁市委宣传部牵头建设并管理，宿迁日报社负责开发、运营。截至目前， “速新闻”已有用户145万，是宿迁地区影响力最大的新媒体平台。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "distance" }, [
                      _vm._v(
                        "\n                                    荣获“全国媒体融合创新先锋品牌奖”、“第四届全省宣传思想文化工作先进集体”、“江苏省优秀全民阅读新媒体推广平台”、“全国政务”最具影响力发布“品牌奖”、“江苏省新媒体运用创新奖”、 “全国最具本土传播力品牌奖”、“江苏报业年度融合创新项目一等奖”。                                        \n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "info distance" }, [
                      _vm._v(
                        "“速新闻”技术咨询电话：0527-84389919\n                            "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c("div", { staticClass: "title", attrs: { id: "rexian" } }, [
                    _c("i"),
                    _vm._v("新闻热线")
                  ])
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("p", [
                    _vm._v(
                      "\n                                新闻报道，请您联系：13951395151\n                        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c(
                    "div",
                    { staticClass: "title", attrs: { id: "guanggao" } },
                    [_c("i"), _vm._v("广告合作")]
                  )
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("p", [
                    _vm._v(
                      "\n                     商务合作、品牌推广，请您联系：0527-84389900\n                        "
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 320100
          ? _c("div", { staticClass: "main clear" }, [
              _c("div", { staticClass: "about n-about" }, [
                _c("dl", [
                  _c("div", { staticClass: "title" }, [
                    _c("i"),
                    _vm._v("关于我们")
                  ])
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        "《南京晨报》是新华报业传媒集团主办的一张综合型都市类报纸。\n                                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "《南京晨报》创刊于1996年1月18日，创刊时名为《每日桥报》，2000年11月28日改为现名。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "隶属新华报业传媒集团。南京晨报立足南京，覆盖南京都市圈，90%以上读者在南京主城。"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c("div", { staticClass: "title", attrs: { id: "rexian" } }, [
                    _c("i"),
                    _vm._v("新闻热线")
                  ])
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("p", [
                    _vm._v(
                      "\n                                    新闻报道，请您联系：025—58682301\n                            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c(
                    "div",
                    { staticClass: "title", attrs: { id: "guanggao" } },
                    [_c("i"), _vm._v("广告合作")]
                  )
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("p", [
                    _vm._v(
                      "\n                         商务合作、品牌推广，请您联系：025—58682358\n                            "
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7b916f02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b916f02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/page/news-pc/about.vue
// module id = null
// module chunks = 